import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=5f59b811"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"
import style0 from "./Leave.vue?vue&type=style&index=0&id=5f59b811&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports